/* warning: there some commanded area for example purpose */
import React, { useReducer } from 'react';
import StorelessContext from './storelessContext';
import storelessReducer from './storelessReducer';
import { UPDATE_CHART_INSTANCE } from './types';

const StorelessState = (props) => {
  const initialState = {
    chartInstance: {},
  };

  const [state, dispatch] = useReducer(storelessReducer, initialState);

  // const updateState = async () => {

  // dispatch({ type: UPDATE_CHART_INSTANCE, payload: data });
  // };
  // const getNews = async () => {
  //   try {
  //     let res = await axios.get("https://node-hnapi.herokuapp.com/news");
  //     let { data } = res;

  //     dispatch({ type: GET_NEWS, payload: data });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  //   const getDescription = async (id) => {
  //     try {
  //       let res = await axios.get(`https://node-hnapi.herokuapp.com/item/${id}`);
  //       let { data } = res;

  //       dispatch({ type: GET_DESCRIPTION, payload: data });
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  const updateChartInstance = (instance) => {
    dispatch({ type: UPDATE_CHART_INSTANCE, payload: instance });
  };

  return (
    <StorelessContext.Provider
      value={{
        chartInstance: state.chartInstance,
        // news: state.news,
        // activeNews: state.activeNews,
        // getNews,
        // getDescription,
        updateChartInstance,
      }}
    >
      {props.children}
    </StorelessContext.Provider>
  );
};

export default StorelessState;
